const collator = new Intl.Collator("de", {
  numeric: true,
  sensitivity: "base"
});

function compareValues(left, right) {
  const leftEmpty = left === null || left === undefined || left === "";
  const rightEmpty = right === null || right === undefined || right === "";
  if (leftEmpty || rightEmpty) {
    if (leftEmpty && rightEmpty) return 0;
    return leftEmpty ? 1 : -1;
  }

  const leftGermanDate = parseGermanDate(left);
  const rightGermanDate = parseGermanDate(right);
  if (leftGermanDate !== null || rightGermanDate !== null) {
    if (leftGermanDate === null) return 1;
    if (rightGermanDate === null) return -1;
    return leftGermanDate - rightGermanDate;
  }

  const leftNumber = Number(left);
  const rightNumber = Number(right);
  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
    return leftNumber - rightNumber;
  }
  return collator.compare(String(left), String(right));
}

function parseGermanDate(value) {
  const match = String(value).match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!match) return null;
  const [, day, month, year] = match;
  return Date.UTC(Number(year), Number(month) - 1, Number(day));
}

export function sortJssRows(rows, valueGetter, direction = "asc") {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((left, right) => {
      const result = compareValues(
        valueGetter(left.row),
        valueGetter(right.row)
      );
      return (direction === "desc" ? -result : result) || left.index - right.index;
    })
    .map(({ row }) => row);
}
